<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{ 'Events'|translate }}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="accent mr-2" @click="launchEdit" :disabled="!$can('update', 'Points')">
                        <v-icon small class="mr-2">fa-plus</v-icon>
                        {{ 'Add manually'|translate }}
                    </v-btn>
                    <v-dialog v-model="dialog" persistent max-width="800">
                        <v-card v-if="dialog">
                            <v-card-title class="primary white--text title">
                                <span >{{ 'Manually add event'|translate }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-text-field :label="'Type'|translate" autofocus
                                              v-model="editedItem.type"></v-text-field>
                                <v-text-field :label="'Time'|translate" type="datetime-local" clearable
                                              v-model="editedItem.timestamp"></v-text-field>
                                <label>Data</label>
                                <editor v-model="editedItem.data" @init="editorInit" lang="json" theme="twilight" width="100%"
                                        height="500"></editor>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn outline class="mr-2" @click="dialog=false">{{ 'Cancel'|translate }}</v-btn>
                                <v-btn class="primary mr-2 elevation-4" @click="logEvent" :disabled="!$can('update', 'Points')">
                                    {{ 'Save'|translate }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card-actions>

                <v-card-text>

                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {logEventToDB} from '../helper'
import editor from 'vue2-ace-editor'
import moment from "moment/moment";

export default {
    name: 'Events',
    components: {editor},
    data() {
        return {
            dialog: false,
            editedItem: {},
        }
    },
    watch: {

    },

    methods: {
        editorInit: function () {
            require('brace/ext/language_tools')
            require('brace/mode/json')
            require('brace/theme/twilight')
        },
        launchEdit() {
            this.editedItem = JSON.parse(JSON.stringify({
                type: 'carnotDashboard.custom',
                data:"{}",
                timestamp:moment().format("YYYY-MM-DD HH:mm:ss"),
                source:process.env.VUE_APP_MOBILE_MODE ? "carnotMobile" : "carnotDashboard",
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name
            }))
            this.dialog = true
        },
        async logEvent () {
            let payload = JSON.parse(JSON.stringify(this.editedItem))
            if (payload.data&&payload.data!==""){
                payload.data=JSON.parse(payload.data)
            } else {
                payload.data=null
            }
            if (payload.timestamp&&payload.timestamp!==""){
                payload.timestamp=moment(payload.timestamp).format("YYYY-MM-DD HH:mm:ss")
            } else {
                payload.timestamp=null
            }
            await logEventToDB(payload)
            this.dialog = false
            this.editedItem=null
            this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Event saved')})
        }
    }
}
</script>

<style scoped>

</style>
